import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { useT } from "@/i18n";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, ArrowRight, ShieldCheck } from "lucide-react";

export default function ResetPassword() {
  const { t } = useT();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error(t("Parola trebuie să aibă minim 6 caractere."));
    if (pw !== pw2) return toast.error(t("Parolele nu coincid."));
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(data.message || t("Parola a fost resetată."));
      navigate("/login");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen klus-grid-bg flex flex-col items-center justify-center px-4 py-10">
      <Link to="/" className="mb-8"><Logo className="h-9" /></Link>
      <div className="w-full max-w-md animate-fade-up">
        <div className="bg-card border border-slate-800 rounded-3xl p-6 sm:p-8">
          <ShieldCheck className="w-10 h-10 text-primary mb-3" />
          <h1 className="text-3xl font-extrabold text-white mb-1">{t("Setează o parolă nouă")}</h1>
          <p className="text-slate-400 text-sm mb-6">{t("Alege o parolă sigură pentru contul tău.")}</p>
          {!token ? (
            <p className="text-amber-400 text-sm">{t("Link invalid. Solicită din nou resetarea din pagina „Ai uitat parola?\".")}</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-xs uppercase tracking-widest text-slate-400">{t("Parolă nouă")}</Label>
                <Input type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
                  data-testid="reset-password" className="mt-1.5 bg-slate-900 border-slate-700 h-12" />
              </div>
              <div>
                <Label className="text-xs uppercase tracking-widest text-slate-400">{t("Confirmă parola")}</Label>
                <Input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)}
                  data-testid="reset-password2" className="mt-1.5 bg-slate-900 border-slate-700 h-12" />
              </div>
              <Button type="submit" disabled={loading} data-testid="reset-submit"
                className="w-full h-12 bg-primary hover:bg-primary/90 text-white text-base">
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <>{t("Resetează parola")} <ArrowRight className="w-4 h-4 ml-1.5" /></>}
              </Button>
            </form>
          )}
          <p className="text-sm text-slate-400 mt-6 text-center">
            <Link to="/login" className="text-primary hover:underline">{t("Înapoi la autentificare")}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
